import React from 'react';

type MethodCardProps = {
  title: string;
  subTitle: string;
  iconRenderer: () => React.ReactNode;
  bottomContentRenderer: () => string | React.ReactNode;
  onClick: () => void;
};

const MethodCard = ({ title, subTitle, iconRenderer, bottomContentRenderer, onClick }: MethodCardProps) => {
  const icon = iconRenderer();
  const bottomContent = bottomContentRenderer();

  return (
    <article
      className="w-full cursor-pointer rounded bg-[#333F57] px-1.5 py-1.5 sm:px-2.5"
      onClick={onClick}
    >
      <div className="flex w-full p-2">
        <div className="flex flex-1 flex-col items-start justify-start">
          <span className="font-bold vt-font-highlight-font-family vt-text-size-big">{title || ''}</span>
          <span className="vt-body-text-dark">{subTitle || ''}</span>
        </div>
        {icon && (
          <div className="flex h-full items-center justify-end rounded p-2 vt-containers-settings-box-light-bg">
            {icon}
          </div>
        )}
      </div>
      <div className="my-1 h-[1px] w-full rounded bg-[var(--colors-dark-100)]" />
      <div className="flex w-full justify-center p-1">
        <span className="vt-text-size-magical vt-body-text-darker">{bottomContent}</span>
      </div>
    </article>
  );
};

export default MethodCard;
